<lms-breadcrumb></lms-breadcrumb>
<ng-container *ngIf="!noGroups">
  <lms-toolbar [options]="toolbarConfig">
    <div class="lms-toolbar__item" *lmsProfileGuard="'mars.create'" tools-actions>
      <gl-button
        color-primary
        [text]="'mars.create' | translate"
        [routerLink]="['/mars/new']"
        title="{{ 'mars.create' | translate }}"
      ></gl-button>
    </div>
  </lms-toolbar>

  <lms-mars-group-list [listId]="listId"></lms-mars-group-list>
</ng-container>

<!-- void groups -->
<div *ngIf="noGroups">
  <div class="main__void">
    <div class="main__void--icon">
      <span class="glicon-class"></span>
    </div>
    <span class="main__void--title">{{ 'mars.noGroups' | translate }}</span>
    <span class="main__void--subtitle">{{ 'mars.noGroupsInfo' | translate }}.</span>
    <gl-button
      *lmsProfileGuard="'mars.create'"
      color-primary
      [text]="'mars.create' | translate"
      [routerLink]="['/mars/new']"
      title="{{ 'mars.create' | translate }}"
    ></gl-button>
  </div>
</div>
